import React, { useRef, useState, useEffect } from 'react';

interface AnimatedCollapsibleProps {
  isOpen: boolean;
  children: React.ReactNode;
  className?: string;
  durationClass?: string; // e.g. "duration-300"
}

export const AnimatedCollapsible: React.FC<AnimatedCollapsibleProps> = ({
  isOpen,
  children,
  className = '',
  durationClass = 'duration-300',
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState<string>('0px');

  useEffect(() => {
    if (isOpen) {
      if (contentRef.current) {
        setMaxHeight(`${contentRef.current.scrollHeight}px`);
      }
    } else {
      setMaxHeight('0px');
    }
  }, [isOpen, children]); // Re-measure height if children content dynamically updates

  return (
    <div
      ref={contentRef}
      className={`overflow-hidden transition-[max-height,opacity] ease-in-out ${durationClass} ${className}`}
      style={{
        maxHeight,
        opacity: isOpen ? 1 : 0,
      }}
    >
      {children}
    </div>
  );
};
export default AnimatedCollapsible;
